import { useState } from "react";
import { Link, useParams } from "react-router-dom";

const PREVIEW_BASE: string =
  (import.meta as unknown as { env: Record<string, string | undefined> }).env.VITE_PREVIEW_BASE ??
  "http://localhost:5173";

type VariantChoice = "none" | "control" | "variant";

export function Preview() {
  const { slug = "" } = useParams();
  const [variantChoice, setVariantChoice] = useState<VariantChoice>("none");
  const src = buildPreviewUrl(slug, variantChoice);

  return (
    <div className="flex flex-col gap-3">
      <div className="flex items-center justify-between">
        <Link
          to={`/quizzes/${slug}`}
          className="mono text-[0.7rem] uppercase tracking-[0.16em] text-mars-white/50 hover:text-mars-white"
        >
          &larr; Back to {slug}
        </Link>
        <a
          href={src}
          target="_blank"
          rel="noreferrer"
          className="mono text-[0.7rem] uppercase tracking-[0.16em] text-mars-orange hover:text-mars-orange-deep"
        >
          Open in new tab
        </a>
      </div>
      <fieldset className="flex items-center gap-4">
        <legend className="sr-only">Force Intelligems variant</legend>
        <span className="mono text-[0.65rem] uppercase tracking-[0.14em] text-mars-white/40">
          Variant:
        </span>
        {(["none", "control", "variant"] as const).map((opt) => (
          <label key={opt} className="flex items-center gap-2 text-xs text-mars-white/70">
            <input
              type="radio"
              name="variant"
              value={opt}
              checked={variantChoice === opt}
              onChange={() => setVariantChoice(opt)}
            />
            {opt === "none" ? "Auto" : opt}
          </label>
        ))}
      </fieldset>
      <iframe
        title={`Preview ${slug}`}
        src={src}
        className="h-[80vh] w-full rounded-2xl border border-mars-line bg-mars-black"
      />
      <p className="mono text-[0.65rem] uppercase tracking-[0.14em] text-mars-white/40">
        Preview mode — submissions and analytics disabled. Set{" "}
        <code className="rounded bg-mars-charcoal px-1 py-0.5">VITE_PREVIEW_BASE</code> to point at
        a different widget URL.
      </p>
    </div>
  );
}

function buildPreviewUrl(slug: string, variantChoice: VariantChoice): string {
  const url = new URL(PREVIEW_BASE, window.location.origin);
  url.searchParams.set("quiz", slug);
  url.searchParams.set("preview", "1");
  if (variantChoice !== "none") {
    url.searchParams.set("variant", variantChoice);
  }
  return url.toString();
}
